import React from 'react';

function InfoPaywall({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M13.8793 15.9207L13.7529 16.4921C13.3736 16.6571 13.0709 16.7831 12.8448 16.8698C12.6188 16.9566 12.3563 17 12.0575 17C11.5977 17 11.2404 16.8761 10.9856 16.6286C10.7308 16.381 10.6034 16.0667 10.6034 15.6857C10.6034 15.5376 10.613 15.3862 10.6322 15.2317C10.6513 15.0772 10.682 14.9026 10.7241 14.7079L11.1954 12.854C11.2375 12.6762 11.273 12.5079 11.3017 12.3492C11.3305 12.1905 11.3448 12.0455 11.3448 11.9143C11.3448 11.6772 11.3008 11.5122 11.2126 11.419C11.1245 11.3259 10.9559 11.2794 10.7069 11.2794C10.5843 11.2794 10.4588 11.3005 10.3305 11.3429C10.2021 11.3852 10.092 11.4254 10 11.4635L10.1264 10.8921C10.4368 10.7524 10.7337 10.6328 11.0172 10.5333C11.3008 10.4339 11.569 10.3841 11.8218 10.3841C12.2778 10.3841 12.6293 10.5058 12.8764 10.7492C13.1236 10.9926 13.2471 11.309 13.2471 11.6984C13.2471 11.7788 13.2385 11.9206 13.2213 12.1238C13.204 12.327 13.1724 12.5132 13.1264 12.6825L12.6552 14.5301C12.6169 14.6783 12.5824 14.8476 12.5517 15.0381C12.5211 15.2286 12.5057 15.3725 12.5057 15.4699C12.5057 15.7154 12.5556 15.8825 12.6552 15.9715C12.7548 16.0603 12.9272 16.1047 13.1724 16.1047C13.2874 16.1047 13.4176 16.0825 13.5632 16.0381C13.7088 15.9936 13.8142 15.9545 13.8793 15.9207ZM14 8.16825C14 8.48995 13.8898 8.76402 13.6695 8.99048C13.4492 9.21693 13.1839 9.33016 12.8736 9.33016C12.5632 9.33016 12.2969 9.21693 12.0747 8.99048C11.8525 8.76402 11.7414 8.48995 11.7414 8.16825C11.7414 7.84655 11.8525 7.57143 12.0747 7.34286C12.2969 7.11428 12.5632 7 12.8736 7C13.1839 7 13.4492 7.11428 13.6695 7.34286C13.8898 7.57143 14 7.84655 14 8.16825Z"
        fill={stroke}
      />
      <circle cx="12" cy="12" r="9" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}

export default InfoPaywall;
